import {Content, JSONSettingsEquipmentStatus} from "./data/models/JSONSettingsEquipmentStatus";

export const filterStatusSettings = (settings: JSONSettingsEquipmentStatus): Content => {
    return settings.content.find((content) => content.guid === 'f83929d0-0282-40fb-8ecc-c7d2cbb83030');
}